import { candleData, candleDataMt5 } from '@/mocks/market';

const MAX = 92;

export type CandleVariant = 'mt4' | 'mt5';

export default function CandleChart({
  compact = false,
  variant = 'mt4',
}: {
  compact?: boolean;
  variant?: CandleVariant;
}) {
  const series = variant === 'mt5' ? candleDataMt5 : candleData;

  return (
    <div className={`flex w-full items-end gap-1.5 ${compact ? 'h-32' : 'h-48 md:h-56'}`}>
      {series.map((candle, index) => {
        const bodyHigh = Math.max(candle.bodyTop, candle.bodyBottom);
        const bodyLow = Math.min(candle.bodyTop, candle.bodyBottom);
        const bodyTop = (1 - bodyHigh / MAX) * 100;
        const bodyHeight = Math.max(6, ((bodyHigh - bodyLow) / MAX) * 100);
        const wickTop = (1 - candle.high / MAX) * 100;
        const wickHeight = ((candle.high - candle.low) / MAX) * 100;
        return (
          <div key={index} className="relative flex h-full flex-1 justify-center">
            <div
              className="absolute w-px bg-background-300"
              style={{ top: `${wickTop}%`, height: `${wickHeight}%` }}
            />
            <div
              className={`absolute w-full max-w-[14px] rounded-sm ${
                candle.up ? 'bg-secondary-500' : 'bg-accent-500'
              }`}
              style={{ top: `${bodyTop}%`, height: `${bodyHeight}%` }}
            />
          </div>
        );
      })}
    </div>
  );
}